import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const ProjectFilters = ({ filters, onFilterChange, onClearFilters }) => {
  const aduTypeOptions = [
    { value: 'all', label: 'All ADU Types' },
    { value: 'detached', label: 'Detached ADU' },
    { value: 'attached', label: 'Attached ADU' },
    { value: 'garage', label: 'Garage Conversion' },
    { value: 'basement', label: 'Basement Conversion' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'planning', label: 'Planning' },
    { value: 'permits', label: 'Permits' },
    { value: 'foundation', label: 'Foundation' },
    { value: 'framing', label: 'Framing' },
    { value: 'systems', label: 'Systems' },
    { value: 'finishing', label: 'Finishing' },
    { value: 'completion', label: 'Completion' }
  ];

  const priorityOptions = [
    { value: 'all', label: 'All Priorities' },
    { value: 'high', label: 'High Priority' },
    { value: 'medium', label: 'Medium Priority' },
    { value: 'low', label: 'Low Priority' }
  ];

  const hasActiveFilters = 
    filters?.aduType !== 'all' || 
    filters?.status !== 'all' || 
    filters?.priority !== 'all' || 
    filters?.search !== '';

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-sm border border-border mb-4 md:mb-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <div className="flex items-center gap-2 md:gap-3">
          <Icon name="Filter" size={20} className="text-primary" />
          <h3 className="font-semibold text-base md:text-lg text-foreground">
            Filter Projects
          </h3>
        </div>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            iconPosition="left"
            onClick={onClearFilters}
          >
            Clear All
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        <Input
          type="search"
          placeholder="Search projects..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
        />

        <Select
          placeholder="Select ADU type"
          options={aduTypeOptions}
          value={filters?.aduType}
          onChange={(value) => onFilterChange('aduType', value)}
        />

        <Select
          placeholder="Select status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          placeholder="Select priority"
          options={priorityOptions}
          value={filters?.priority}
          onChange={(value) => onFilterChange('priority', value)}
        />
      </div>
    </div>
  );
};

export default ProjectFilters;